var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileBlack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9,
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 8.5 11.5)",
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(1 0 0 -1 14.5 11.5)",
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14C15.8219 14 15.8789 14.0297 15.9108 14.0635C15.9383 14.0927 15.9455 14.1202 15.9392 14.1533C15.6335 15.7741 14.2094 17 12.5 17C10.7906 17 9.36648 15.7741 9.06077 14.1533C9.05453 14.1202 9.06167 14.0927 9.08925 14.0635C9.12111 14.0297 9.17813 14 9.25 14C9.36478 14 9.54849 14.1121 9.6333 14.3866C10.0114 15.6101 11.1511 16.5 12.5 16.5C13.8489 16.5 14.9886 15.6101 15.3667 14.3866C15.4515 14.1121 15.6352 14 15.75 14Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileBlack1);
export default __webpack_public_path__ + "static/media/smile_black_1.8d9f3f706b4270ee720b9837b4de77bd.svg";
export { ForwardRef as ReactComponent };